import webWeights from "../helpers/webWeights";

const systemWeights = {
  thin: webWeights.thin,
  light: webWeights.light,
  regular: webWeights.regular,
  semibold: webWeights.semibold,
  bold: webWeights.bold
};

export default systemWeights;
